// @flow
import React from 'react';
import classNames from 'classnames';
import { ContactDetails } from 'components/organisms/contactDetails';
import { ReservationForm } from 'components/organisms/reservationForm';
import { useViewport } from 'components/templates/viewportProvider';
import type { Contact, Vertical } from 'types/common';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: {
    contact: Contact,
    verticals: Array<Vertical>,
    verticalId: number | null,
  },
};

export const ReservationFormOverlay = (props: Props) => {
  const { height, isMobile } = useViewport();
  const {
    type,
    formData: { contact },
    data,
    descriptionType,
  } = props;

  const {
    reservationOutletId,
    morningOpeningTime,
    morningClosingTime,
    eveningOpeningTime,
    eveningClosingTime,
  } = props.data;

  const containerClass = classNames({
    'no-padding': isMobile,
    'section-container': !isMobile,
  });

  return (
    <div
      className={containerClass}
      style={
        isMobile ? { height: '130vh !important' } : { height, paddingTop: 0 }
      }
      id={'contact'}
    >
      <div
        className={
          isMobile
            ? type === 'no-padding'
              ? 'contact-container '
              : 'contact-container'
            : 'contact-container'
        }
      >
        <div className={'reservation-info-container'}>
          <ContactDetails contact={data} type={descriptionType} />
        </div>
        <div className={'reservation-form-container'}>
          <ReservationForm
            isMobile={isMobile}
            contactEmail={contact.email}
            outletId={reservationOutletId}
            morningOpeningTime={morningOpeningTime}
            morningClosingTime={morningClosingTime}
            eveningOpeningTime={eveningOpeningTime}
            eveningClosingTime={eveningClosingTime}
          />
        </div>
      </div>
    </div>
  );
};
